import { Grid, Typography } from "@mui/material";
import { useResponsive } from "../../../Modulo_Responsive/Hooks/useResponsive";

const data = [
    {
        id: "1",
        titulo: "Nuestra misión",
        parrafos: [
            "Acompañar a personas, comunidades y organizaciones en el diseño, adecuación y gestión de espacios que respeten la vida, el trabajo y el entorno, integrando arquitectura, Seguridad y Salud en el Trabajo y soluciones técnicas adaptadas a cada necesidad.",
            "Queremos transformar diagnósticos y riesgos en oportunidades de mejora, aportando orden, tranquilidad y calidad de vida, para que cada intervención no solo cumpla una norma, sino que tenga un impacto positivo y duradero en quienes usan el espacio."
        ]
    },
    {
        id: "2",
        titulo: "Nuestra visión",
        parrafos: [
            "Ser reconocidos como una firma que pone a las personas en el centro del diseño y la ejecución, promoviendo una cultura donde la seguridad, la funcionalidad y el cuidado del espacio sean parte natural del día a día.",
            "Aspiramos a generar impacto social positivo a través de proyectos mejor pensados, entornos de trabajo más seguros y comunidades más conscientes, consolidándonos como un aliado técnico y humano para propiedad horizontal, empresas y organizaciones que buscan construir y mantener espacios con sentido y responsabilidad."
        ]
    }
];

const MisionVision_Home = () => {
    const { sCell } = useResponsive();

    return (
        <Grid
            container
            justifyContent="center"
            alignItems="center"
            size={{ xs: 12 }}
            sx={{ background:"#F5F6F7", py:sCell?8:16 }}
            component="section"
        >
            <Grid
                container
                justifyContent="center"
                alignItems="flex-start"
                size={{ xs: 12, sm: 12, md: 10 }}
                sx={{ maxWidth: 1400, px: 3, }}
                spacing={6}
            >
                {data.map((item) => (
                    <Grid key={item.id} size={{ xs: 12, sm: 12, md: 6 }}>
                        <Typography
                            component="h2"
                            variant={"h2"}
                            sx={{
                                mb: 4,
                            }}
                        >
                            {item.titulo}
                        </Typography>

                        {item.parrafos.map((parrafo, index) => (
                            <Typography
                                key={index}
                                component="p"
                                variant={"body1"}
                                sx={{

                                    mb: index < item.parrafos.length - 1 ? 2 : 0,
                                }}
                            >
                                {parrafo}
                            </Typography>
                        ))}
                    </Grid>
                ))}
            </Grid>
        </Grid>
    );
};

export default MisionVision_Home;